import { ref, onMounted, onBeforeUnmount } from 'vue-demi';
import { isElementInViewport } from '../util';
const { throttle } = require('@futuweb/fego-bridge');

export function useHeaderFixed({ tradeIdeaRef }) {
    const shouldFixed = ref(false);

    const checkShouldFixed = throttle(() => {
        const tabHeaderFake = tradeIdeaRef.value.querySelector('.trade-idea-tab-fake');
        const tabHeaderReal = tradeIdeaRef.value.querySelector('.trade-idea-tab-real');
        shouldFixed.value = !isElementInViewport(tabHeaderFake, 'entire');
        if (shouldFixed.value) {
            const height = tabHeaderReal.getBoundingClientRect().height;
            tabHeaderFake.style.height = `${height }px`;
            tabHeaderReal.classList.add('trade-idea-tab-fixed');
        } else {
            tabHeaderFake.style.height = `${0 }px`;
            tabHeaderReal.classList.remove('trade-idea-tab-fixed');
        }
    }, 100);

    const watchScroll = () => {
        window.addEventListener('scroll', checkShouldFixed);
    };

    const unWatchScroll = () => {
        window.addEventListener('scroll', checkShouldFixed);
    };

    onMounted(() => {
        watchScroll();
        checkShouldFixed();
    });

    onBeforeUnmount(() => {
        unWatchScroll();
    });

    return {
        shouldFixed
    };
}
